module.exports = __webpack_public_path__ + "img/gameplan-home.39de2118.png";